import { ReactNode } from "react";

/**
 * The bordered field box used by the flight and interstate search bars —
 * label sits inside the box above the control. Shared so the LagBus, Train
 * and Cowry tabs match them exactly rather than re-deriving the classes.
 */
export function FieldShell({
  name,
  dark = false,
  children,
}: {
  name: string;
  dark?: boolean;
  children: ReactNode;
}) {
  return (
    <div
      className={
        dark
          ? "border-white/25 bg-white/10 outline-none flex flex-col border-[1px] py-1 h-14 rounded-[14px] w-full text-white px-3 focus-within:border-orange-400 transition-colors"
          : "border-[#302D6340] bg-white outline-none flex flex-col border-[1px] py-1 h-14 rounded-[4px] w-full text-[#171717] px-3 focus:border-b-[#EE723A] focus:border-2"
      }
    >
      <label
        className={dark ? "text-xs text-white/80" : "text-xs text-slate-500"}
      >
        {name}
      </label>
      {children}
    </div>
  );
}

/** Borderless control that sits inside a FieldShell. */
export const fieldInputClass = (dark: boolean, extra = "") =>
  [
    "w-full h-8 text-sm bg-transparent outline-none",
    dark ? "text-white placeholder:text-white/40 [color-scheme:dark]" : "",
    extra,
  ]
    .filter(Boolean)
    .join(" ");
